import React, { type FC } from 'react'
import ScrollableAnchor from 'react-scrollable-anchor'
import TextContent from '../../section-tabs/text-content'
import Container from '../../container'
import { Grid } from '../../UIKit/system'
import Title from '../../title'
import styled from 'styled-components'

interface ProductTechSpecsProps {
  items?: {
    _uid: string;
    title: string;
    content: Record<string, any>;
    secondContent: Record<string, any>;
  }[];
}

export const ProductTechSpecs: FC<ProductTechSpecsProps> = (props) => {
  const { items } = props

  if (!items || items.length === 0) return null

  const mappedItems = items.map((item) => ({
    ...item,
    text: item.content,
    secondText: item.secondContent
  }))

  return (
    <ScrollableAnchor id="tech-specs">
      <Container large py={[48, 96]}>
        <SectionGrid>
          <Grid width={['auto', 180]} alignContent="start">
            <Title as="h2" fontSizeSmall>
              Tech Specs
            </Title>
          </Grid>
          <div>
            <TextContent items={mappedItems} />
          </div>
        </SectionGrid>
      </Container>
    </ScrollableAnchor>
  )
}

const SectionGrid = styled(Grid).attrs(() => ({
  gridAutoFlow: ['row', 'row', 'column'],
  gridGap: [30, 30, 99],
  gridTemplateColumns: ['auto', 'auto', 'auto 1fr']
}))``
